import React from 'react';
import { usePublicShows } from '../lib/shows';

export function ShowsPage() {
  const { shows, loading } = usePublicShows();

  return (
    <section className="panel inner-page">
      <div className="panel-header">
        <p className="eyebrow">Routing & Availability</p>
        <h2>Upcoming Shows</h2>
        <p className="lede">
          West Coast availability with flexible routing. Reach out for holds, private events, and support slots.
        </p>
      </div>
      {loading && <p className="meta">Loading dates…</p>}
      <div className="grid shows">
        {shows.map((show) => (
          <div key={show.date + show.venue} className="card show-card">
            <div className="date-chip">{show.date}</div>
            <div className="show-body">
              <h3>{show.venue}</h3>
              <p>{show.location}</p>
              {show.note && <p className="meta">{show.note}</p>}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
